import { registerComponent } from '@gig/magic-common';
import CookiePopupComponent from './cookie-popup.js';

var CookiePopup = registerComponent(CookiePopupComponent);

export { CookiePopup };
